import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Select,
  Space,
  Switch,
  InputNumber,
  Radio,
  Upload,
  Spin,
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  CloseOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
  DeleteFilled,
  EditFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import textToVoice from "controllers/textToVoice";
import textToFile from "controllers/textToFile";
import s3Controller from "controllers/s3Controller";
import textToFile2 from "controllers/textToFile2";
import s3Controller2 from "controllers/s3Controller2";
import dayjs from "dayjs";
import Excel from "exceljs";
import fileSaver from "file-saver";
import readExcel from "read-excel-file";

import phoneticFuntions from "./controller/phoneticFuntions";
import SentenceProgress from "./SentenceProgress";
import sentenceZipUpload from "controllers/sentenceZipUpload";
import constituentFuntions from "./controller/constituentFuntions";
import textFunction from "controllers/textFunction";
import changeFunction from "controllers/changeFunction";
import ExcelMorpheme from "./ExcelMorpheme";
import errorMorpheme from "controllers/errorMorpheme";
import UploadProgressBar from "./UploadProgressBar";
import GuideList from "./GuideList";
import SentenceEngInput from "./SentenceEngInput";
import SentenceEngCheck from "./SentenceEngCheck";
import SentenceEngInputTextarea from "./SentenceEngInputTextarea";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

function SentenceEng({filter, filterHandler}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reRender, setReRender] = useState(false);
  const [groups, setGroups] = useState([]);
  const [courses, setCourses] = useState([]);
  const [stages, setStages] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [units, setUnits] = useState([]);
  const [subUnits, setSubUnits] = useState([]);
  const [sentencePatterns, setSentencePatterns] = useState([]);
  const [tenses, setTenses] = useState([]);
  const [constituentColor, setConstituentColor] = useState({});
  const [morphemeAuth, setMorphemeAuth] = useState([]);
  const [languages, setLanguages] = useState([])

  const [confirmLoading, setConfirmLoading] = useState(false)
  const [preSourceDataKor, setPreSourceDataKor] = useState([]);
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [upLoadPopup, setUpLoadPopup] = useState(false);
  const [sentenceUpload, setSentenceUpload] = useState(false);
  const compareRef = useRef(null);
  const stopRef = useRef(false);
  const formRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [fileList, setFileList] = useState([]); //업로드시 선택된 파일 리스트

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [10, 50, 100, 200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
    filters: {
      group: filter.group,
      course: filter.course,
      stage: filter.stage,
      chapter: filter.chapter,
      unit: filter.unit,
      subUnit: filter.subUnit,
      sentenceStatus: filter.sentenceStatus,
      errorStatus: "all",
      searchFilter: "",
    },
  });
  const [uploadProgress, setUploadProgress] = useState([false, 0, 0,""])
  const [morphemeProgress, setMorphemeProgress] = useState([false, 0, 0]);
  const [phoneticProgress, setPhoneticProgress] = useState([false, 0, 0]);
  const [createFileProgress, setCreateFileProgress] = useState([false, 0, 0]);
  const [startEnd, setStartEnd] = useState([0, 0]);
  const [isStop, setStop] = useState({
    morpheme: false,
    phonetic: false,
    createFile: false,
  });

  const morphemeOption = [10, 1000];
  const phoneticOption = [10, 1500];

  const sentenceUploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]); // 여러개 할 경우 앞에 ...fileList를 붙임
      return false;
    },
    fileList,
  };

  const columns = [
    Table.SELECTION_COLUMN,
    {
      width: "50px",
      render: (_) => <a onClick={() => insertHandler(_)}>{<PlusOutlined />}</a>,
    },
    {
      title: "문장코드",
      dataIndex: "id",
      key: "id",
      width: "100px",
    },
    {
      title: "문장상태",
      dataIndex: "sentenceStatus",
      key: "sentenceStatus",
      width: "100px",
      render: (_, record) => (
        <Switch
          className="sentenceSwitch"
          defaultChecked={_ === "Y" ? true : false}
          checkedChildren="편집"
          unCheckedChildren="운영"
          disabled={_ === "Y" && !record.error_status && record.ContentSettingTense_code && record.ContentSettingSentencePattern_code ? false : true}
          checked={_ === "Y" ? true : false}
          onChange={() => runningHandler(record)}
        ></Switch>
      ),
    },
    {
      title: "서브유닛 코드",
      dataIndex: "ContentSubUnit_code",
      key: "ContentSubUnit_code",
      width: "130px",
    },
    {
      title: "문장번호",
      dataIndex: "seq",
      key: "seq",
      width: "100px",
      render: (_, record) => (
        <InputNumber
          min={1}
          defaultValue={_}
          style={{
            width: "65px",
            border: _ === record.seq_origin ? "" : "solid 2px red",
          }}
          value={_}
          onChange={(value) => {
            const instance = sourceDataKor.slice();
            instance[record.num].seq = value;
            setSourceDataKor(instance);
          }}
          onFocus={() => {
            compareRef.current = _;
          }}
          onBlur={() => {
            if (compareRef.current !== _) {
              singleChange(_, record, "seq");
            }
            compareRef.current = null;
          }}
        ></InputNumber>
      ),
    },
    {
      title: "영어문장",
      dataIndex: "sentence_text",
      key: "sentence_text",
      width: "300px",
      render: (_, record)=><SentenceEngInputTextarea _={_} record={record} singleChange={singleChange} field="sentence_text"/>
    },
    {
      title: "발음기호",
      dataIndex: "roman_sentence_text",
      key: "roman_sentence_text",
      width: "300px",
      render: (_, record) => (
        <Space style={{ justifyContent: "space-between" }}>
          <Input.TextArea
            autoSize
            style={{
              width: "250px",
              border:
                _ === record.roman_sentence_text_origin ? "" : "solid 2px red",
            }}
            defaultValue={_}
            value={_}
            onChange={(e) => {
              const newText = e.target.value;
              const instance = sourceDataKor.slice();
              instance[record.num].roman_sentence_text = newText;
              instance[record.num].error_status = errorMorpheme(instance[record.num])
              setSourceDataKor(instance);
            }}
            onFocus={() => {
              compareRef.current = _;
            }}
            onBlur={() => {
              if (compareRef.current !== _) {
                singleChange(_, record, "roman_sentence_text");
              }
              compareRef.current = null;
            }}
          ></Input.TextArea>
          <a style={{ whiteSpace: "pre" }} onClick={() => phonetic(record)}>
            생성
          </a>
        </Space>
      ),
    },
    {
      title: "시제",
      dataIndex: "ContentSettingTense_code",
      key: "ContentSettingTense_code",
      width: "180px",
      render: (_, record) => (
        <Select
          style={{
            width: "150px",
            border:
              _ === record.ContentSettingTense_code_origin
                ? ""
                : "solid 2px red",
          }}
          options={tenses}
          defaultValue={_}
          value={_}
          onChange={(value) => {
            const instance = sourceDataKor.slice();
            instance[record.num].ContentSettingTense_code = value;
            setSourceDataKor(instance);
            if (compareRef.current !== value) {
              singleChange(value, record, "ContentSettingTense_code");
              compareRef.current = value;
            }
          }}
          onFocus={() => {
            compareRef.current = _;
          }}
          onBlur={() => {
            compareRef.current = null;
          }}
        ></Select>
      ),
    },
    {
      title: "형식",
      dataIndex: "ContentSettingSentencePattern_code",
      key: "ContentSettingSentencePattern_code",
      width: "160px",
      render: (_, record) => (
        <Select
          style={{
            width: "130px",
            border:
              _ === record.ContentSettingSentencePattern_code_origin
                ? ""
                : "solid 2px red",
          }}
          options={sentencePatterns}
          defaultValue={_}
          value={_}
          onChange={(value) => {
            const instance = sourceDataKor.slice();
            instance[record.num].ContentSettingSentencePattern_code = value;
            instance[record.num].error_status = errorMorpheme(instance[record.num])
            setSourceDataKor(instance);
            if (compareRef.current !== value) {
              singleChange(value, record, "ContentSettingSentencePattern_code");
              compareRef.current = value;
            }
          }}
          onFocus={() => {
            compareRef.current = _;
          }}
          onBlur={() => {
            compareRef.current = null;
          }}
        ></Select>
      ),
    },
    {
      title: "성분 학습",
      dataIndex: "learning_sentence_elements_yn",
      key: "learning_sentence_elements_yn",
      width: "90px",
      render: (_, record)=><SentenceEngCheck _={_} record={record} singleChange={singleChange} field="learning_sentence_elements_yn"/>
    },
    {
      title: "어휘 학습",
      dataIndex: "learning_vocabulary_yn",
      key: "learning_vocabulary_yn",
      width: "90px",
      render: (_, record)=><SentenceEngCheck _={_} record={record} singleChange={singleChange} field="learning_vocabulary_yn"/>
    },
    {
      title: "학습 어휘",
      dataIndex: "vocabulary_text",
      key: "vocabulary_text",
      width: "200px",
      render: (_, record)=> <SentenceEngInput _={_} record={record} singleChange={singleChange} field="vocabulary_text"/>
    },
    {
      title: "종속절유무",
      dataIndex: "dependent_clause_yn",
      key: "dependent_clause_yn",
      width: "100px",
      render: (_, record) => (
        <Switch
          className="sentenceSwitch"
          style={{
            background: _ === "Y" ? "blue" : "grey",
            outline:
              _ === record.dependent_clause_yn_origin ? "" : "solid 3px red",
          }}
          defaultChecked={_ === "Y" ? true : false}
          checked={_ === "Y" ? true : false}
          checkedChildren="있음"
          unCheckedChildren="없음"
          onChange={(value) => {
            const instance = sourceDataKor.slice();
            instance[record.num].dependent_clause_yn = value ? "Y" : "N";
            setSourceDataKor(instance);
            singleChange(value ? "Y" : "N", record, "dependent_clause_yn");
          }}
        ></Switch>
      ),
    },
    {
      title: "음성파일(1.0배속)",
      dataIndex: "sentence_voice_filename",
      key: "sentence_voice_filename",
      width: "270px",
      render: (_, record) => (
        <Space>
          <a
            style={{ whiteSpace: "pre" }}
            onClick={() => listenSectenceVoice(record)}
          >
            듣기
          </a>
          <a
            style={{ whiteSpace: "pre" }}
            onClick={() => {
              createVoiceFile(record);
            }}
          >
            생성
          </a>
          <div
            style={{
              color: _ === record.sentence_voice_filename_origin ? "" : "red",
              width: "160px",
            }}
          >
            {_}
          </div>
          {!_ ? null : (
            <a
              style={{ whiteSpace: "pre" }}
              onClick={() => listenFileVoice(_, record)}
            >
              듣기
            </a>
          )}
        </Space>
      ),
    },
    {
      title: "에러",
      key: "error_status",
      width: "100px",
      render: (_,record) => 
        <div style={{background:"red", color:"yellow",textAlign:"center"}}>
          {record.error_status}
        </div>
    },
    {
      title: "성분색상",
      dataIndex: "",
      key: "",
      width: "300px",
      render: (_, record) => (
        <div>
          <div>
            {record.morpheme
              ? record.morpheme.map((spellEle, spellIndex) => {
                  // spellEle, spellIndex는 문장의 쉼표구분에 따른 값들
                  // console.log(spellEle);
                  return (
                    <ExcelMorpheme
                      key={spellIndex}
                      spellIndex={spellIndex}
                      spellEle={spellEle}
                      rowIdx={record.num}
                      morpheme={spellEle.morpheme}
                      changeMorpheme={changeMorpheme}
                      constituentColor={constituentColor}
                    />
                  );
                })
              : null}
          </div>
          <a onClick={() => constituent(record)}>분석</a>
        </div>
      ),
    },
    {
      title: "주어",
      dataIndex: "sentence_subject",
      key: "sentence_subject",
      width: "150px",
      render: (_, record) => (
        <div
          style={{
            color: _ === record.sentence_subject_origin ? "" : "red",
            width: "100px",
          }}
        >
          {_ !== record.sentence_subject_origin && !_ ? "null" : _}
        </div>
      ),
    },
    {
      title: "동사",
      dataIndex: "sentence_verb",
      key: "sentence_verb",
      width: "150px",
      render: (_, record) => (
        <div
          style={{
            color: _ === record.sentence_verb_origin ? "" : "red",
            width: "100px",
          }}
        >
          {_ !== record.sentence_verb_origin && !_ ? "null" : _}
        </div>
      ),
    },
    {
      title: "목적어",
      dataIndex: "sentence_direct_object",
      key: "sentence_direct_object",
      width: "150px",
      render: (_, record) => (
        <div
          style={{
            color: _ === record.sentence_direct_object_origin ? "" : "red",
            width: "100px",
          }}
        >
          {_ !== record.sentence_direct_object_origin && !_ ? "null" : _}
        </div>
      ),
    },
    {
      title: "간접목적어",
      dataIndex: "sentence_indirect_object",
      key: "sentence_indirect_object",
      width: "150px",
      render: (_, record) => (
        <div
          style={{
            color: _ === record.sentence_indirect_object_origin ? "" : "red",
            width: "100px",
          }}
        >
          {_ !== record.sentence_indirect_object_origin && !_ ? "null" : _}
        </div>
      ),
    },
    {
      title: "보어",
      dataIndex: "sentence_complement",
      key: "sentence_complement",
      width: "150px",
      render: (_, record) => (
        <div
          style={{
            color: _ === record.sentence_complement_origin ? "" : "red",
            width: "100px",
          }}
        >
          {_ !== record.sentence_complement_origin && !_ ? "null" : _}
        </div>
      ),
    },
    {
      title: "부사",
      dataIndex: "sentence_adverb",
      key: "sentence_adverb",
      width: "150px",
      render: (_, record) => (
        <div
          style={{
            color: _ === record.sentence_adverb_origin ? "" : "red",
            width: "100px",
          }}
        >
          {_ !== record.sentence_adverb_origin && !_ ? "null" : _}
        </div>
      ),
    },
    {
      title: "기타",
      dataIndex: "sentence_etc",
      key: "sentence_etc",
      width: "150px",
      render: (_, record) => (
        <div
          style={{
            color: _ === record.sentence_etc_origin ? "" : "red",
            width: "100px",
          }}
        >
          {_ !== record.sentence_etc_origin && !_ ? "null" : _}
        </div>
      ),
    },
    {
      title: "처리",
      dataIndex: "",
      width:100,
      render: (_) => (
        <a
          style={{ margin: "0px 5px", whiteSpace: "pre" }}
          onClick={() => {
            Modal.confirm({
              style: { whiteSpace: "pre-line" },
              title: "삭제 확인",
              content: `삭제를 하시면 복구할 수 없습니다.
              선택한 문장을 정말 삭제 하시겠습니까?`,
              okText: "삭제",
              cancelText: "취소",
              cancelButtonProps: { type: "primary" },
              okButtonProps: { type: "default" },
              onOk: async () => {
                // singleChange("Y", _, "delete_yn");

                try {
                  const deleteResult = await axios.post(
                    `${backend}/contents/content_sentence/sentence/delete`,
                    {
                      table: "ContentSentenceEditMaster",
                      field: "delete_yn",
                      value: ["Y"],
                      condition: [_.id],
                      ContentSubUnit_codes: [_.ContentSubUnit_code],
                    }
                  );
                  if (deleteResult.status === 200) {
                    try {
                      let files = [{Key:"sentence/"+_.ContentChapter_code+"/"+_.sentence_voice_filename}]
   
                      for (let el of languages) {
                        const result = await s3Controller2.s3List("translate/"+_.ContentChapter_code+"/"+el.locale+"/translate_"+_.id+"_")
                        if(result.Contents.length !== 0) {
                          for (let ele of result.Contents) {
                            files.push({Key: ele.Key})
                          }
                        }
                      }
  
                      s3Controller.s3DeleteFiles(files, (err, data) => {
                        if(err) {
                          Modal.error({
                            title: "에러",
                            okText: "확인",
                            content: `aws 서버에러가 발생하여 삭제하지 못했습니다.`,
                            onOk: ()=>{
                              axios.post(
                                `${backend}/contents/content_sentence/sentence/delete`,
                                {
                                  table: "ContentSentenceEditMaster",
                                  field: "delete_yn",
                                  value: ["N"],
                                  condition: [_.id],
                                  ContentSubUnit_codes: [_.ContentSubUnit_code],
                                }
                              )
                            }
                          });
                        } else {
                          axios
                          .delete(`${backend}/contents/content_sentence/sentence/filename`)
                          .then(res=>{
                            console.log("filename 삭제 완료")
                          })
                          .catch(err=>{
                            console.log("filename 삭제 에러")
                          })
  
                          setReRender(!reRender);
                          let sentence = 0
                          let translate = 0
                          data.Deleted.forEach(el=>{
                            const plus = el.Key.split("/")[0]
                            if(plus === "sentence") sentence+=1
                            if(plus === "translate") translate+=1
                          })
                          Modal.success({
                            title: "삭제 완료",
                            okText: "확인",
                            content: `1개 문장의 영어파일 ${sentence}개와 해석파일 ${translate}개가 정상적으로 삭제되었습니다.`,
                          });
                        }
                      })
                    } catch (err) {
                      Modal.error({
                        title: "에러",
                        okText: "확인",
                        content: `aws 서버에러가 발생하여 voicefile을 삭제하지 못했습니다.`,
                        onOk: ()=>{
                          const valuesN = Array.from({ length: selectedKeys.length }, () => "N");
                          axios.post(
                            `${backend}/contents/content_sentence/sentence/delete`,
                            {
                              table: "ContentSentenceEditMaster",
                              field: "delete_yn",
                              value: ["N"],
                              condition: [_.id],
                              ContentSubUnit_codes: [_.ContentSubUnit_code],
                            }
                          )
                          .then(res=>{
                          })
                          .catch(err=>{
                            console.log(err)
                          })
                        }
                      });
                    }
                  }
                } catch (err) {
                  console.log(err);
                  Modal.error({
                    title: "에러",
                    okText: "확인",
                    content: `서버에러가 발생하여 삭제하지 못했습니다.`,
                  });
                }
              },
            });
          }}
        >
          삭제
        </a>
      ),
    },
    {}
  ];

  const getSourceData = (data) => {
    const total = data.data[1][0]["FOUND_ROWS()"];
    // console.log(data)
    const sourceData = data.data[0].map((el, idx) => {
      el.num = idx;
      return el;
    });
    const instance = changeFunction(sourceData);

    setSourceDataKor(instance);
    setPreSourceDataKor(JSON.parse(JSON.stringify(sourceData))); // db에러 시 되돌리기 위한 소스
    setSelectedRows([]);
    setSelectedKeys([]);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: total, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
  };

  const groupFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        group: value,
        course: "all",
        stage: "all",
        chapter: "all",
        unit: "all",
        subUnit: "all",
      },
    });

    filterHandler({
      group: value,
      course: "all",
      stage: "all",
      chapter: "all",
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const courseFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        course: value,
        stage: "all",
        chapter: "all",
        unit: "all",
        subUnit: "all",
      },
    });

    filterHandler({
      group: tableParams.filters.group,
      course: value,
      stage: "all",
      chapter: "all",
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const stageFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        stage: value,
        chapter: "all",
        unit: "all",
        subUnit: "all",
      },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: value,
      chapter: "all",
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const chapterFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        chapter: value,
        unit: "all",
        subUnit: "all",
      },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: value,
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };
  
  const unitFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, unit: value, subUnit: "all" },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: tableParams.filters.chapter,
      unit: value,
      subUnit: "all",
      sentenceStatus: "all",
    })
  };
  
  const subUnitFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, subUnit: value },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: tableParams.filters.chapter,
      unit: tableParams.filters.unit,
      subUnit: value,
      sentenceStatus: "all",
    })
  };
  
  const sentenceStatusFilter = (value) => {
    // console.log(value);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, sentenceStatus: value },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: tableParams.filters.chapter,
      unit: tableParams.filters.unit,
      subUnit: tableParams.filters.subUnit,
      sentenceStatus: value,
    })
  };

  const errorStatusFilter = (value) => {
    // console.log(value);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, errorStatus: value },
    });
  };

  const onSearch = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, searchFilter: value },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      ...tableParams,
      pagination,
    });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setSourceDataKor([]);
    }
  };

  function sleep(sec) {
    return new Promise((resolve) => setTimeout(resolve, sec));
  }

  const singleChange = async (_, record, field) => {
    try {
      // console.log(compareRef.current)
      const changeRecordResult = await axios.post(
        `${backend}/contents/content_sentence/sentence/changeRecord`,
        {
          table: "ContentSentenceEditMaster",
          field: field,
          value: [_],
          condition: [record.id],
          record: [record],
        }
      );
      if (field === "delete_yn" || field === "seq") {
        setReRender(!reRender);
      } else {
        if (changeRecordResult.status === 200) {
          const instance = sourceDataKor.slice();
          instance[record.num][field] =  _
          // const compare = await phoneticFuntions.compareData(
          //   originData[record.num],
          //   instance[record.num]
          // );
          const compare = phoneticFuntions.compareData2(instance[record.num]);
          if (compare) {
            instance[record.num].sentenceStatus = "N";
          } else {
            instance[record.num].sentenceStatus = "Y";
          }
          setSourceDataKor(instance);
          setPreSourceDataKor(JSON.parse(JSON.stringify(instance)));
        }
      }
    } catch (err) {
      console.log("에러", err);
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "서버에러가 발생하여 정상적으로 변경하지 못했습니다.",
        afterClose: () => {
          setSourceDataKor(JSON.parse(JSON.stringify(preSourceDataKor)));
        },
      });
    }
  };

  // 수동으로 변경했을때 로직에 대해서 전체적으로 다시 검토가 필요하다.

  const phonetic = async (record) => {
    const originInstance = JSON.parse(JSON.stringify(sourceDataKor));
    const instance = sourceDataKor.slice();

    try {
      const word = record.sentence_text;
      if (!word) {
        return Modal.error({
          title: "문장에러",
          okText: "확인",
          content: "발음기호를 생성할 영어문장이 없습니다.",
        });
      }
      const text = await phoneticFuntions.dotChange(word);

      const phoneticResult = await phoneticFuntions.getPhonetic(text);

      const changedValue = await phoneticFuntions.phoneticErrorChange(
        phoneticResult.data.data[0]
      );
      
      const convertedValue = changedValue.replaceAll(String.fromCharCode(160)," ")

      instance[record.num].roman_sentence_text = convertedValue;
      instance[record.num].error_status = errorMorpheme(instance[record.num])

      // const compare = await phoneticFuntions.compareData(
      //   originData[record.num],
      //   instance[record.num]
      // );
      const compare = phoneticFuntions.compareData2(instance[record.num]);

      if (compare) {
        instance[record.num].sentenceStatus = "N";
      } else {
        instance[record.num].sentenceStatus = "Y";
      }
      setSourceDataKor(instance);

      const changeRecordResult = await axios.post(
        `${backend}/contents/content_sentence/sentence/changeRecord`,
        {
          table: "ContentSentenceEditMaster",
          field: "roman_sentence_text",
          value: [convertedValue],
          condition: [record.id],
          record: [record],
        }
      );
      setPreSourceDataKor(instance);
    } catch (err) {
      console.log(err);
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "서버에러가 발생하여 정상적으로 변경하지 못했습니다.",
        afterClose: () => {
          setSourceDataKor(originInstance);
        },
      });
    }
  };

  const phoneticAll = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "발음기호 생성",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      try {
        const progressNumber = phoneticOption[0];
        const max = startEnd[1];
        let startNum = startEnd[0];
        let endNum =
          max < startNum + progressNumber - 1
            ? max
            : startNum + progressNumber - 1;

        for (let i = 0; i < selectedRows.length; i++) {
          const text = selectedRows[i].sentence_text;
          if (!text || text === "") {
            return Modal.error({
              title: "문장 에러",
              okText: "확인",
              content: `${selectedRows[i].id}번에 문장이 없습니다. 문장을 입력하고 다시 시도하세요.`,
            });
          }
        }

        while (startNum <= max) {
          let isContinue = true;
          const instance = selectedRows.slice();
          const instanceAll = sourceDataKor.slice();
          const originInstance = JSON.parse(JSON.stringify(instanceAll));
          phoneticProgress[0] = true;
          if (startNum === 0) {
            setPhoneticProgress([true, startNum, max + 1]);
          }

          let ids = []; // DB업데이트 시 key값이 필요하기 때문
          let a = "";

          for (let i = startNum; i <= endNum; i++) {
            ids.push(instance[i].id);
            const word = instance[i].sentence_text;
            const text = await phoneticFuntions.dotChange(word);
            if (i === startNum) {
              a += text;
            } else {
              a += " " + text;
            }
          }

          const b = a.split(" ");

          const allData = b.reduce((acc, cur) => {
            return (acc = acc + "+" + cur);
          });

          const phoneticResult = await phoneticFuntions.getPhonetic(allData);

          const changedValues = phoneticResult.data.data.map((ele, idx) => {
            const num = instance[startNum + idx].num;

            const changedValue = phoneticFuntions.phoneticErrorChange(ele);
            const convertedValue = changedValue.replaceAll(String.fromCharCode(160)," ")

            instanceAll[num].roman_sentence_text = convertedValue;
            instanceAll[num].error_status = errorMorpheme(instanceAll[num])

            // const compare = phoneticFuntions.compareData(
            //   originData[num],
            //   instanceAll[num]
            // );
            const compare = phoneticFuntions.compareData2(instanceAll[num]);

            if (compare) {
              instanceAll[num].sentenceStatus = "N";
            } else {
              instanceAll[num].sentenceStatus = "Y";
            }

            return convertedValue;
          });
          setSourceDataKor(instanceAll);

          try {
            const changeRecordResult = await axios.post(
              `${backend}/contents/content_sentence/sentence/changeRecord`,
              {
                table: "ContentSentenceEditMaster",
                field: "roman_sentence_text",
                value: changedValues,
                condition: ids,
                record: instance,
              }
            );
            setPreSourceDataKor(instanceAll);
          } catch (err) {
            console.log(err);
            isContinue = false;
            Modal.error({
              title: "에러",
              okText: "확인",
              content: `서버에러가 발생하여 ${ids[0]} 문장부터 발음기호 생성이 중지되었습니다.`,
              afterClose: () => {
                setSourceDataKor(originInstance);
                setPhoneticProgress([false, 0, 0]);
              },
            });
          }

          if (isStop.phonetic) {
            break;
          }
          if (!isContinue) {
            break;
          }
          startNum = startNum + progressNumber;
          endNum =
            endNum + progressNumber <= max ? endNum + progressNumber : max;
          if (endNum === max) {
            stopRef.current = true;
          }
          setPhoneticProgress([true, startNum, max + 1]);
          await sleep(phoneticOption[1]);
        }

        // setSourceDataKor(instance);
        setPhoneticProgress([false, 0, 0]);
        if (isStop.phonetic === true) {
          Modal.info({
            title: "작업 중지",
            okText: "확인",
            content: `문장코드 ${selectedRows[endNum].id}까지 진행 후 작업을 중지했습니다.`,
            afterClose: () => {
              isStop.phonetic = false;
            },
          });
        }
      } catch (err) {
        console.log(err);
        setPhoneticProgress([false, 0, 0]);
      }
    }
  };

  function changeMorpheme(key, morpheme1, morpheme2, spellIndex, rowIdx) {
    const instance = sourceDataKor.slice(0);
    const originInstance = JSON.parse(JSON.stringify(sourceDataKor));

    const before = instance[rowIdx][morpheme1]
      ? instance[rowIdx][morpheme1].split(",").map((el) => Number(el))
      : [];
    const after = instance[rowIdx][morpheme2]
      ? instance[rowIdx][morpheme2].split(",").map((el) => Number(el))
      : [];
    const start = before.indexOf(key[0]);

    before.splice(start, key.length);

    let afterResult = [...after, ...key].sort((a, b) => a - b);
    let beforeResult;

    if (before.length === 0) {
      beforeResult = null;
    } else {
      beforeResult = before.join(",");
    }

    instance[rowIdx].morpheme[spellIndex].morpheme = morpheme2;
    if (morpheme1 !== 0) instance[rowIdx][morpheme1] = beforeResult;
    if (morpheme2 !== 0) instance[rowIdx][morpheme2] = afterResult.join(",");

    instance[rowIdx].error_status = errorMorpheme(instance[rowIdx])
    const compare = phoneticFuntions.compareData2(instance[rowIdx]);
    if (compare) {
      instance[rowIdx].sentenceStatus = "N";
    } else {
      instance[rowIdx].sentenceStatus = "Y";
    }

    // console.log(beforeResult)
    // console.log(afterResult.join(','))
    setSourceDataKor(instance);
    axios
      .post(
        `${backend}/contents/content_sentence/constituent/change_morpheme`,
        { rowData: [instance[rowIdx]] }
      )
      .then((data) => {})
      .catch((err) => {
        console.log(err);
        Modal.error({
          title: "에러",
          okText: "확인",
          content: `서버에러가 발생하여 성분을 변경하지 못했습니다.`,
          afterClose: () => {
            setSourceDataKor(originInstance);
          },
        });
      });
  }

  const constituent = async (record) => {
    if (!record.sentence_text) {
      Modal.info({
        title: "문장성분 분석",
        okText: "확인",
        content: "성분을 분석할 영어문장이 없습니다.",
      });
    } else {
      const instance = sourceDataKor.slice(0);
      const originInstance = JSON.parse(JSON.stringify(sourceDataKor));

      axios
        .post(
          `${backend}/contents/content_sentence/constituent/morpheme_text`,
          {
            text: record.sentence_text,
            verbP: record.ContentSettingSentencePattern_code || "",
            authStatus: morphemeAuth,
          },
          {
            withCredentials: true,
          }
        )
        .then((data) => {
          try {
            const result = data.data.data[0];
            if (!result.length) {
              Modal.error({
                title: "성분분석 에러",
                okText: "확인",
                content:
                  "성분분석이 정상적으로 이루어지지 않았습니다. 관리자에게 문의하세요.",
              });
            }
            const resultArr = constituentFuntions.morpheme(result);

            const morphemeText = {
              sub: "sentence_subject",
              verb: "sentence_verb",
              direct_object: "sentence_direct_object",
              indirect_object: "sentence_indirect_object",
              complement: "sentence_complement",
              adverb: "sentence_adverb",
              etc: "sentence_etc",
            };
            const morphemeInfo = {
              sentence_subject: [],
              sentence_verb: [],
              sentence_complement: [],
              sentence_direct_object: [],
              sentence_indirect_object: [],
              sentence_adverb: [],
              sentence_etc: [],
            };

            const morphemeResult = textFunction(
              record.sentence_text,
              morphemeInfo
            );

            // 분석된 성분을 숫자로 바꿔주는 역할
            morphemeResult.forEach((ele, idx) => {
              const num = resultArr.indexOf(ele.value.trim());
              // console.log(num)
              if (num !== -1) {
                ele.morpheme = morphemeText[result[num].morpheme];
                resultArr[num] = null;
              }
            });
            instance[record.num].morpheme = morphemeResult;
            instance[record.num].sentence_subject = null;
            instance[record.num].sentence_verb = null;
            instance[record.num].sentence_direct_object = null;
            instance[record.num].sentence_indirect_object = null;
            instance[record.num].sentence_complement = null;
            instance[record.num].sentence_adverb = null;
            instance[record.num].sentence_etc = null;

            const mor = instance[record.num].morpheme;

            for (let i = 0; i < mor.length; i++) {
              const text = mor[i].key.join(",");
              if (mor[i].morpheme === 0) {
                continue;
              }
              if (instance[record.num][mor[i].morpheme] === null) {
                instance[record.num][mor[i].morpheme] = text;
              } else {
                instance[record.num][mor[i].morpheme] =
                  instance[record.num][mor[i].morpheme] + "," + text;
              }
            }
            instance[record.num].error_status = errorMorpheme(instance[record.num])
            const compare = phoneticFuntions.compareData2(instance[record.num]);
            if (compare) {
              instance[record.num].sentenceStatus = "N";
            } else {
              instance[record.num].sentenceStatus = "Y";
            }
            setSourceDataKor(instance);

            axios
              .post(
                `${backend}/contents/content_sentence/constituent/change_morpheme`,
                { rowData: [record] }
              )
              .then((data) => {})
              .catch((err) => {
                console.log(err);
                if(err.response && err.response.status===401) {
                  navigate("/auth")
                } else {
                  Modal.error({
                    title: "에러",
                    okText: "확인",
                    content: `서버에러가 발생하여 성분을 변경하지 못했습니다.`,
                    afterClose: () => {
                      setSourceDataKor(originInstance);
                    },
                  });
                }
              });
          } catch (err) {
            console.log(err);
            if(err.response && err.response.status===401) {
              navigate("/auth")
            } else {
              Modal.error({
                afterClose: () => {
                  setSourceDataKor(originInstance);
                },
                title: "에러",
                okText: "확인",
                content: `작업 중 에러가 발생하였습니다.`,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 501) {
            Modal.error({
              title: "인증 에러",
              okText: "확인",
              content: `VISL서버에 인증이 필요합니다. "확인"을 누르면 자동으로 인증됩니다. 그 이후 다시 시도해주세요.`,
              onOk: () => {
                setLoading(true)
                axios
                  .get(
                    `${backend}/contents/content_sentence/constituent/morpheme_ready`,
                    { withCredentials: true }
                  )
                  .then((data) => {
                    setLoading(false);
                    setMorphemeAuth(data.data)
                    Modal.info({
                      title: "VISL인증 완료",
                      okText: "확인",
                      content: `인증이 완료되었습니. 이제 성분분석 작업이 가능합니다.`,
                    })
                  })
                  .catch((err) => {
                    setLoading(false)
                    console.log(err);
                    Modal.error({
                      title: "VISL인증 에러",
                      okText: "확인",
                      content: `인증 도중 에러가 발생하였습니다. 다시 시도하시고 계속 에러가 발생되면 관리자에게 문의하세요.`,
                    })
                  });
              },
            });
          } else {
            console.log(err);
            Modal.error({
              afterClose: () => {
                setSourceDataKor(originInstance);
              },
              title: "에러",
              okText: "확인",
              content: `작업 중 에러가 발생하였습니다.`,
            });
          }
        });
    }
  };

  const constituentAll = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "문장성분 분석",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      try {
        const progressNumber = morphemeOption[0];
        const max = startEnd[1];
        let startNum = startEnd[0];
        let endNum =
          max < startNum + progressNumber - 1
            ? max
            : startNum + progressNumber - 1;

        for (let i = 0; i < selectedRows.length; i++) {
          const text = selectedRows[i].sentence_text;
          if (!text || text === "") {
            return Modal.error({
              title: "문장 에러",
              okText: "확인",
              content: `${selectedRows[i].id}번에 문장이 없습니다. 문장을 입력하고 다시 시도하세요.`,
            });
          }
        }

        while (startNum <= max) {
          let isContinue = true;
          const instance = selectedRows.slice();
          const instanceAll = sourceDataKor.slice();
          const originInstance = JSON.parse(JSON.stringify(instanceAll));
          let changedRows = [];
          morphemeProgress[0] = true;
          if (startNum === 0) {
            setMorphemeProgress([true, startNum, max + 1]);
          }

          // let ids = [instance[startNum].id]; // DB업데이트 시 key값이 필요하기 때문
          // let aPattern = [instance[startNum].ContentSettingSentencePattern_code]
          // let a = instance[startNum].sentence_text || "_."; // 문장들

          let ids = [];
          let aPattern = [];
          let a = "";

          for (let i = startNum; i <= endNum; i++) {
            const text = instance[i].sentence_text;
            const lastSpell = text || text === "" ? text[text.length - 1] : "_";

            ids.push(instance[i].id);
            aPattern.push(instance[i].ContentSettingSentencePattern_code);

            if (lastSpell !== "." && lastSpell !== "?" && lastSpell !== "!") {
              a = a + " " + (text || "_") + ".";
            } else {
              a = a + " " + (text || "_");
            }
          }

          const aText = a.split(" ");

          let textAll = aText.reduce((acc, cur) => {
            if (cur.indexOf(".") === -1) {
              return (acc = acc + "+" + cur);
            } else {
              return (acc = acc + "+" + cur + ".");
            }
          });

          const axiosResult = await axios.post(
            `${backend}/contents/content_sentence/constituent/morpheme_text`,
            {
              text: textAll,
              verbP: aPattern || "",
              authStatus: morphemeAuth,
            },
            {
              withCredentials: true,
            }
          );
          const axiosData = axiosResult.data.data;

          if (!axiosData[0].length) {
            Modal.error({
              title: "성분분석 에러",
              okText: "확인",
              content:
                "성분분석이 정상적으로 이루어지지 않았습니다. 관리자에게 문의하세요.",
            });
            setMorphemeProgress([false, 0, 0]);
          }
          const morphemeText = {
            sub: "sentence_subject",
            verb: "sentence_verb",
            direct_object: "sentence_direct_object",
            indirect_object: "sentence_indirect_object",
            complement: "sentence_complement",
            adverb: "sentence_adverb",
            etc: "sentence_etc",
          };
          const morphemeInfo = {
            sentence_subject: [],
            sentence_verb: [],
            sentence_complement: [],
            sentence_direct_object: [],
            sentence_indirect_object: [],
            sentence_adverb: [],
            sentence_etc: [],
          };

          for (let i = startNum; i <= endNum; i++) {
            const result = axiosData[i - startNum];
            const textValue = instance[i].sentence_text;
            const resultArr = constituentFuntions.morpheme(result);

            const morphemeResult = textFunction(textValue, morphemeInfo);

            // 분석된 성분을 morpheme으로 바꿔주는 역할
            morphemeResult.forEach((ele, idx) => {
              const num = resultArr.indexOf(ele.value.trim());
              if (num !== -1) {
                ele.morpheme = morphemeText[result[num].morpheme];
                resultArr[num] = null;
              }
            });
            const rowNum = instance[i].num;
            instanceAll[rowNum].morpheme = morphemeResult;
            instanceAll[rowNum].sentence_subject = null;
            instanceAll[rowNum].sentence_verb = null;
            instanceAll[rowNum].sentence_direct_object = null;
            instanceAll[rowNum].sentence_indirect_object = null;
            instanceAll[rowNum].sentence_complement = null;
            instanceAll[rowNum].sentence_adverb = null;
            instanceAll[rowNum].sentence_etc = null;

            const mor = instanceAll[rowNum].morpheme;

            for (let n = 0; n < mor.length; n++) {
              const text = mor[n].key.join(",");
              if (mor[n].morpheme === 0) {
                continue;
              }
              if (instanceAll[rowNum][mor[n].morpheme] === null) {
                instanceAll[rowNum][mor[n].morpheme] = text;
              } else {
                instanceAll[rowNum][mor[n].morpheme] =
                  instanceAll[rowNum][mor[n].morpheme] + "," + text;
              }
            }
            instanceAll[rowNum].error_status = errorMorpheme(instanceAll[rowNum])
            const compare = phoneticFuntions.compareData2(instanceAll[rowNum]);
            if (compare) {
              instanceAll[rowNum].sentenceStatus = "N";
            } else {
              instanceAll[rowNum].sentenceStatus = "Y";
            }

            changedRows.push(instanceAll[rowNum]);
          }
          setSourceDataKor(instanceAll);

          try {
            const changeRecordResult = await axios.post(
              `${backend}/contents/content_sentence/constituent/change_morpheme`,
              { rowData: changedRows }
            );
            setPreSourceDataKor(instanceAll);
          } catch (err) {
            console.log(err);
            isContinue = false;
            Modal.error({
              title: "에러",
              okText: "확인",
              content: `서버에러가 발생하여 ${ids[0]} 문장부터 성분분석이 중지되었습니다.`,
              afterClose: () => {
                setSourceDataKor(originInstance);
                setMorphemeProgress([false, 0, 0]);
              },
            });
          }

          if (isStop.morpheme) {
            break;
          }
          if (!isContinue) {
            break;
          }
          startNum = startNum + progressNumber;
          endNum =
            endNum + progressNumber <= max ? endNum + progressNumber : max;
          if (endNum === max) {
            stopRef.current = true;
          }
          setMorphemeProgress([true, startNum, max + 1]);
          await sleep(morphemeOption[1]);
        }

        // setSourceDataKor(instance);
        setMorphemeProgress([false, 0, 0]);
        if (isStop.morpheme === true) {
          Modal.info({
            title: "작업 중지",
            okText: "확인",
            content: `문장코드 ${selectedRows[endNum].id}까지 진행 후 작업을 중지했습니다.`,
            afterClose: () => {
              isStop.morpheme = false;
            },
          });
        }
      } catch (err) {
        console.log(err)
        if (err.response.status === 501) {
          setMorphemeProgress([false, 0, 0]);
          Modal.error({
            title: "인증 에러",
            okText: "확인",
            content: `VISL서버에 인증이 필요합니다. "확인"을 누르면 자동으로 인증됩니다. 그 이후 다시 시도해주세요.`,
            onOk: () => {
              setLoading(true)
              axios
                .get(
                  `${backend}/contents/content_sentence/constituent/morpheme_ready`,
                  { withCredentials: true }
                )
                .then((data) => {
                  setLoading(false);
                  setMorphemeAuth(data.data)
                  Modal.info({
                    title: "VISL인증 완료",
                    okText: "확인",
                    content: `인증이 완료되었습니. 이제 성분분석 작업이 가능합니다.`,
                  })
                })
                .catch((err) => {
                  setLoading(false)
                  console.log(err);
                  Modal.error({
                    title: "VISL인증 에러",
                    okText: "확인",
                    content: `인증 도중 에러가 발생하였습니다. 다시 시도하시고 계속 에러가 발생되면 관리자에게 문의하세요.`,
                  })
                });
            },
          });
        } else {
          console.log(err);
          Modal.error({
            title: "성분분석 에러",
            okText: "확인",
            content:
              "문장분석이 정상적으로 이루어지지 않았습니다. 관리자에게 문의하세요.",
            afterClose: ()=>{setMorphemeProgress([false, 0, 0]);}
          });
        }
      }
    }
  };

  const deleteHandler = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "삭제",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      Modal.confirm({
        style: { whiteSpace: "pre-line" },
        title: "삭제 확인",
        content: `삭제를 하시면 복구할 수 없습니다.
        선택한 문장들을 정말 삭제 하시겠습니까?`,
        okText: "삭제",
        cancelText: "취소",
        cancelButtonProps: { type: "primary" },
        okButtonProps: { type: "default" },
        onOk: async () => {
          const values = Array.from({ length: selectedKeys.length }, () => "Y");
          const ContentSubUnit_codes = [
            ...new Set(selectedRows.map((el) => el.ContentSubUnit_code)),
          ];

          try {
            const deleteResult = await axios.post(
              `${backend}/contents/content_sentence/sentence/delete`,
              {
                table: "ContentSentenceEditMaster",
                field: "delete_yn",
                value: values,
                condition: selectedKeys,
                ContentSubUnit_codes: ContentSubUnit_codes,
              }
            );
            if (deleteResult.status === 200) {
              try {
                const keys = selectedRows.map(el=>{
                  return {Key: "sentence/"+el.ContentChapter_code+"/"+el.sentence_voice_filename}
                })
  
                for (let row of selectedRows) {
                  for (let lang of languages) {
                    const result = await s3Controller2.s3List("translate/"+row.ContentChapter_code+"/"+lang.locale+"/translate_"+row.id+"_")
                    if(result.Contents.length !== 0) {
                      for (let ele of result.Contents) {
                        keys.push({Key: ele.Key})
                      }
                    }
                  }
                }

                s3Controller.s3DeleteFiles(keys, (err, data)=>{
                  if (err) {
                    Modal.error({
                      title: "에러",
                      okText: "확인",
                      content: `aws 서버에러가 발생하여 삭제하지 못했습니다.`,
                      onOk: ()=>{
                        const valuesN = Array.from({ length: selectedKeys.length }, () => "N");
                        axios.post(
                          `${backend}/contents/content_sentence/sentence/delete`,
                          {
                            table: "ContentSentenceEditMaster",
                            field: "delete_yn",
                            value: valuesN,
                            condition: selectedKeys,
                            ContentSubUnit_codes: ContentSubUnit_codes,
                          }
                        );
                      }
                    });
                  } else {
                    axios
                    .delete(`${backend}/contents/content_sentence/sentence/filename`)
                    .then(res=>{
                      console.log("filename 삭제 완료")
                    })
                    .catch(err=>{
                      console.log("filename 삭제 에러")
                    })

                    setReRender(!reRender);
                    let sentence = 0
                    let translate = 0
                    data.Deleted.forEach(el=>{
                      const plus = el.Key.split("/")[0]
                      if(plus === "sentence") sentence+=1
                      if(plus === "translate") translate+=1
                    })
                    Modal.success({
                      title: "삭제 완료",
                      okText: "확인",
                      content: `${selectedKeys.length}개 문장의 영어파일 ${sentence}개와 해석파일 ${translate}개가 정상적으로 삭제되었습니다.`,
                    });
                  }
                })
              } catch (err) {
                Modal.error({
                  title: "에러",
                  okText: "확인",
                  content: `aws 서버에러가 발생하여 voicefile을 삭제하지 못했습니다.`,
                  onOk: ()=>{
                    const valuesN = Array.from({ length: selectedKeys.length }, () => "N");
                    axios.post(
                      `${backend}/contents/content_sentence/sentence/delete`,
                      {
                        table: "ContentSentenceEditMaster",
                        field: "delete_yn",
                        value: valuesN,
                        condition: selectedKeys,
                        ContentSubUnit_codes: ContentSubUnit_codes,
                      }
                    );
                  }
                });
              }
            }  
          } catch (err) {
            console.log(err);
            Modal.error({
              title: "에러",
              okText: "확인",
              content: `서버에러가 발생하여 삭제하지 못했습니다.`,
            });
          }
        },
      });
    }
  };

  const insertHandler = (record) => {
    const { id, seq, ContentSubUnit_code, num } = record;
    // console.log(id, seq, ContentSubUnit_code, num);
    axios
      .post(`${backend}/contents/content_sentence/sentence/insert`, {
        seq,
        ContentSubUnit_code,
      })
      .then((data) => {
        setReRender(!reRender);
      })
      .catch((err) => {
        console.log(err);
        Modal.error({
          title: "에러",
          okText: "확인",
          content: `서버에러가 발생하여 생성하지 못했습니다.`,
        });
      });
  };

  const runningHandler = (record) => {
    let selected = [];
    if (record.id) {
      selected = [record];
    } else {
      selected = selectedRows.filter((el) => el.sentenceStatus === "Y" && !el.error_status);
    }
    // const selected = selectedRows.filter(el=>el.sentenceStatus === "Y")
    if (selected.length === 0) {
      Modal.info({
        title: "운영상태 변경확인",
        okText: "확인",
        content:
          "선택된 문장이 없거나 선택된 문장 중 편집모드인 문장이 없습니다.",
      });
    } else {
      Modal.confirm({
        style: { whiteSpace: "pre-line" },
        title: "운영상태 변경",
        content: `선택한 문장을 운영상태로 변경하시겠습니까 ?`,
        okText: "변경",
        cancelText: "취소",
        cancelButtonProps: { type: "primary" },
        okButtonProps: { type: "default" },
        onOk: async () => {
          try {
            const deleteResult = await axios.post(
              `${backend}/contents/content_sentence/sentence/running`,
              { selected }
            );

            if (deleteResult.status === 200) {
              setReRender(!reRender);
              Modal.success({
                title: "변경 완료",
                okText: "확인",
                content: "정상적으로 변경되었습니다.",
              });
            }
          } catch (err) {
            console.log(err);
            Modal.error({
              title: "에러",
              okText: "확인",
              content: `서버에러가 발생하여 동기화하지 못했습니다.`,
            });
          }
        },
      });
    }
  };

  const errorHandler = async () => {
    setLoading(true)
    axios.get(`${backend}/contents/content_sentence/sentence/error_change`)
    .then(data=>{
      Modal.success({
        title:"오류검사 완료",
        okText:"확인",
        content:`${data.data.data}개의 문장에서 오류가 발견되어 오류표시 하였습니다.`
      })
      setReRender(!reRender)
    })
    .catch(err=>{
      console.log(err)
      setLoading(false)
      if(err.response && err.response.status===401) {
        navigate("/auth")
      }
    })
  }

  const guide = () => {
    Modal.info({
      width: "50vw",
      title: "편집 가이드",
      content: <GuideList/>,
      })
  }

  const listenSectenceVoice = async (record) => {
    if (record.sentence_text === null || record.sentence_text === "") {
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "음성 듣기를 실행할 영어문장이 없습니다.",
      });
    } else {
      const text = record.sentence_text;
      const speedNum = 1.0;
      const name = '<voice name="en-US-EricNeural">';
      const speed = `<prosody rate="${speedNum}">`;

      textToVoice(text, name, speed, (err, result) => {
        Modal.error({
          title: "음성파일 듣기 에러",
          okText: "확인",
          content:
            "Azure SDK에서 에러가 발생하여 정상적으로 듣기를 실행하지 못했습니다.",
        });
      });
    }
  };

  const listenFileVoice = async (_, record) => {
    const bucket = "https://englemining-admin.s3.ap-northeast-2.amazonaws.com/";
    const prefix = `sentence/${record.ContentChapter_code}`;
    const audioUrl = bucket + prefix + "/" + _;

    const audio = new Audio(audioUrl);
    audio.play()
    .catch(err=>{
      console.dir(err)
      Modal.error({
        title: "재생에러",
        content: err.message,
        oktext:"확인"
      })
    })
  };

  const createVoiceFile = async (record) => {
    if (record.sentence_text === null || record.sentence_text === "") {
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "음성파일을 생성할 영어문장이 없습니다.",
      });
    } else {
      const originInstance = JSON.parse(JSON.stringify(sourceDataKor));
      const instance = sourceDataKor.slice();

      const speedNum = 1.0;
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");

      const fileName = `sentence_${record.id}_en_${currentVer}.mp3`;
      const text = record.sentence_text;
      const name = '<voice name="en-US-EricNeural">';
      const speed = `<prosody rate="${speedNum}">`;

      textToFile(
        text,
        name,
        speed,
        fileName,
        `sentence/${record.ContentChapter_code}`,
        (err, data) => {
          if (err) {
            Modal.error({
              title: "업로드 에러",
              okText: "확인",
              content:
                "업로드 중 에러가 발생하였습니다. 재시도 하시고 에러가 계속될 경우 관리자에게 문의하세요.",
            });
          } else {
            const newKey = data.Key;
            const prefix = data.Key.split("_").slice(0, -1).join("_");

            const newFileName =
              data.key.split("/")[data.key.split("/").length - 1];

            instance[record.num].sentence_voice_filename = newFileName;

            const compare = phoneticFuntions.compareData2(instance[record.num]);

            if (compare) {
              instance[record.num].sentenceStatus = "N";
            } else {
              instance[record.num].sentenceStatus = "Y";
            }
            setSourceDataKor(instance);

            axios
              .post(
                `${backend}/contents/content_sentence/sentence/changeRecord`,
                {
                  table: "ContentSentenceEditMaster",
                  field: "sentence_voice_filename",
                  value: [newFileName],
                  condition: [record.id],
                  record: [record]
                }
              )
              .then((data) => {
                // console.log("c");
                // 기존에 등록된 파일 중 동일id에 해당하는 파일을 지워주는 로직
                s3Controller.s3List(prefix, (err, result) => {
                  if (err) {
                    console.log(err);
                  } else {
                    const files = result.Contents.reduce((acc, cur) => {
                      if (cur.Key === newKey) {
                        return acc;
                      } else {
                        acc.push({ Key: cur.Key });
                        return acc;
                      }
                    }, []);
                    if (files.length !== 0) {
                      s3Controller.s3DeleteFiles(files, (err, data) => {
                        if (err) console.log(err);
                      });
                    }
                  }
                });
                // console.log("d");
              })
              .catch((err) => {
                console.log(err);
                s3Controller.s3DeleteFile(newKey, (err, data) => {
                  if (err) console.log(err);
                });
                Modal.error({
                  afterClose: () => {
                    setSourceDataKor(originInstance);
                  },
                  title: "서버에러",
                  okText: "확인",
                  content:
                    "서버에 에러가 발생하여 파일을 생성하지 못했습니다. 다시 시도하여 주시고 에러가 지속된다면 관리자에게 문의해주세요.",
                });
              });
          }
        }
      );
    }
  };

  const createVoiceFileAll = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "문장성분 분석",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      try {
        let continueCreateFile = true;
        const max = selectedRows.length;
        setCreateFileProgress([true, 0, max]);

        for (let i = 0; i < selectedRows.length; i++) {
          if (!continueCreateFile) {
            break;
          }
          if (!selectedRows[i].sentence_text) {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setCreateFileProgress([true, i + 1, max]);
              continue;
            } else {
              setCreateFileProgress([false, 0, 0]);
              break;
            }
          }
          const originInstance = JSON.parse(JSON.stringify(sourceDataKor));
          const instance = sourceDataKor.slice();
          const record = selectedRows[i];
          const speedNum = 1.0;
          const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");

          const fileName = `sentence_${record.id}_en_${currentVer}.mp3`;
          const text = record.sentence_text;
          const name = '<voice name="en-US-EricNeural">';
          const speed = `<prosody rate="${speedNum}">`;
          const data = await textToFile2(
            text,
            name,
            speed,
            fileName,
            `sentence/${record.ContentChapter_code}`
          );
          if (!data.Key) {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setCreateFileProgress([true, i + 1, max]);
              continue;
            } else {
              setCreateFileProgress([false, 0, 0]);
              break;
            }
          }
          const newKey = data.Key;
          const prefix = data.Key.split("_").slice(0, -1).join("_");

          const newFileName =
            data.key.split("/")[data.key.split("/").length - 1];

          instance[record.num].sentence_voice_filename = newFileName;

          const compare = phoneticFuntions.compareData2(instance[record.num]);

          if (compare) {
            instance[record.num].sentenceStatus = "N";
          } else {
            instance[record.num].sentenceStatus = "Y";
          }
          setSourceDataKor(instance);

          try {
            const axiosResult = await axios.post(
              `${backend}/contents/content_sentence/sentence/changeRecord`,
              {
                table: "ContentSentenceEditMaster",
                field: "sentence_voice_filename",
                value: [newFileName],
                condition: [record.id],
                record: [record]
              }
            );
            if (axiosResult.status === 200) {
              const result = await s3Controller2.s3List(prefix);

              const files = result.Contents.reduce((acc, cur) => {
                if (cur.Key === newKey) {
                  return acc;
                } else {
                  acc.push({ Key: cur.Key });
                  return acc;
                }
              }, []);
              if (files.length !== 0) {
                const result = await s3Controller2.s3DeleteFiles(files);
              }
              setCreateFileProgress([true, i + 1, max]);
              if (isStop.createFile) {
                Modal.info({
                  title: "작업 중지",
                  okText: "확인",
                  content: `문장코드 ${selectedRows[i].id}까지 진행 후 작업을 중지했습니다.`,
                  afterClose: () => {
                    isStop.createFile = false;
                  },
                });
                break;
              }
              sleep(200);
            }
          } catch (err) {
            console.log(err);
            const result = await s3Controller2.s3DeleteFile(newKey);
            const modalF = () => {
              return new Promise((resolve, reject) => {
                instance[record.num].sentence_voice_filename =
                  originInstance[record.num].sentence_voice_filename;
                const compare = phoneticFuntions.compareData2(
                  instance[record.num]
                );

                if (compare) {
                  instance[record.num].sentenceStatus = "N";
                } else {
                  instance[record.num].sentenceStatus = "Y";
                }
                setSourceDataKor(originInstance);
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    instance[record.num].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            await modalF().then((data) => {
              continueCreateFile = data;
              if (data) {
                setCreateFileProgress([true, i + 1, max]);
              } else {
                setCreateFileProgress([false, 0, 0]);
              }
            });
          }
        }
        await sleep(1000);
        setCreateFileProgress([false, 0, 0]);
      } catch (err) {
        console.log(err);
        setCreateFileProgress([false, 0, 0]);
        // if (err.response.status === 401) {
        //   Modal.error({
        //     title: "인증 에러",
        //     okText: "확인",
        //     content: "인증이 만료되었습니다. 다시 로그인해주세요.",
        //     afterClose: () => {
        //       navigate("/auth");
        //     },
        //   });
        // }
      }
    }
  };

  const UploadOkHandler = () => {
    if(confirmLoading) return
    const chapter = tableParams.filters.chapter;
    setConfirmLoading(true)
    if (chapter === "all") {
      Modal.error({
        title: "챕터선택 오류",
        content: "압축파일을 생성할 챕터가 선택되지 않았습니다.",
        okText: "확인",
        afterClose: () => {
          setConfirmLoading(false)
          setUpLoadPopup(false);
        },
      });
    } else {
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
      const prefix = `sentence/${chapter}`;
      const path = "voiceFiles/";
      const zipName = "sentence" + "_" + chapter.toLowerCase() + "_" + "en";
      const callback = (err, data) => {
        if (err) {
          console.log(err);
          setConfirmLoading(false)
          setUploadProgress([false,0,0,""])
          Modal.error({
            title: "에러",
            okText: "확인",
            content:
              "에러가 발생하여 정상적으로 압축파일을 생성하지 못하였습니다. 다시 시도하시고 계속 에러가 날 경우 관리자에게 문의하세요.",
          });
        } else {
          const file = data.key.split("/")[data.key.split("/").length - 1];
          const path = data.key.replace(`/${file}`, "");
          Modal.success({
            title: "업로드 성공",
            okText: "확인",
            content: `AWS S3 ${data.Bucket}버킷의 ${path}경로에 ${file}를 등록하였습니다.`,
          });
          setUploadProgress([false,0,0,""])
          setConfirmLoading(false)
          setUpLoadPopup(false);
        }
      };
      const progress = (total,current,fileName) => {
        // console.log(current,"/",total)
        setUploadProgress([true,current,total,fileName])
      }

      sentenceZipUpload(prefix, path, zipName, callback,progress);
    }
  };

  const sentenceUploadHandler = () => {
    const uploadOption = formRef.current.getFieldValue("uploadOption");
    const map = {
      ContentSettingSentencePattern_code: "ContentSettingSentencePattern_code",
      ContentSettingTense_code: "ContentSettingTense_code",
      ContentSubUnit_code: "ContentSubUnit_code",
      delete_yn: "delete_yn",
      dependent_clause_yn: "dependent_clause_yn",
      id: "id",
      roman_sentence_text: "roman_sentence_text",
      sentence_adverb: "sentence_adverb",
      sentence_complement: "sentence_complement",
      sentence_direct_object: "sentence_direct_object",
      sentence_etc: "sentence_etc",
      sentence_indirect_object: "sentence_indirect_object",
      sentence_subject: "sentence_subject",
      sentence_text: "sentence_text",
      sentence_verb: "sentence_verb",
      sentence_voice_filename: "sentence_voice_filename",
      learning_sentence_elements_yn:"learning_sentence_elements_yn",
      learning_vocabulary_yn:"learning_vocabulary_yn",
      vocabulary_text:"vocabulary_text",
      seq: "seq",
    };
    readExcel(fileList[0], { map, includeNullValues: true })
      .then((data) => {
        // console.log(data)
        const val = data.rows.filter((el) => {
          return !el.ContentSubUnit_code || !el.seq;
        });
        if (val.length) {
          return Modal.error({
            title: "업로드 실패",
            okText: "확인",
            content: `서브유닛코드 또는 문장번호가 없는 문장이 있어 업로드를 할 수 없습니다. 서브유닛코드와 문장번호는 필수값입니다.`,
          });
        }
        // console.log(uploadOption)
        axios
          .post(
            `${backend}/contents/content_sentence/constituent/excel_upload`,
            { data, uploadOption }
          )
          .then((data) => {
            // console.log(data)
            if (data.status === 201) {
              return Modal.error({
                title: "파일컨텐츠 에러",
                okText: "확인",
                content:
                  "파일 컨텐츠의 id값 중 중복되는 값이 있습니다. 파일을 확인하세요.",
              });
            }
            Modal.success({
              title: "업로드 완료",
              okText: "확인",
              content: `총 ${data.data.data.all}건 중 업데이트 ${data.data.data.update}건, 신규생성 ${data.data.data.new}건 성공하였습니다.`,
              afterClose: () => {
                setReRender(!reRender);
                setSentenceUpload(false);
                setFileList([]);
              },
            });
          })
          .catch((err) => {
            console.log(err);
            if (err.response.status === 401) {
              navigate("/auth");
            }
            Modal.error({
              title: "서버 에러",
              okText: "확인",
              content: "에러가 발생하여 업로드에 실패하였습니다.",
            });
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const excelDownload = () => {
    if (tableParams.pagination.total === 0) {
      return Modal.error({
        title: "에러",
        okText: "확인",
        content: "다운로드 할 문장이 없습니다.",
      });
    }
    setLoading(true);
    axios
      .post(`${backend}/contents/content_sentence/sentence/read`, {
        filter: tableParams.filters,
      })
      .then(async (data) => {
        const { subUnit, unit, stage, group, course, chapter } =
          tableParams.filters;
        const filters = [subUnit, unit, chapter, stage, course, group];
        const search = tableParams.filters.searchFilter;
        const status = tableParams.filters.sentenceStatus;
        const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
        let fileName = "sentence_All_" + search + "_" + currentVer;
        for (let i = 0; i < filters.length; i++) {
          if (filters[i] !== "all") {
            fileName = filters[i] + "_" + search + "_" + currentVer;
            break;
          }
        }

        const map = [
          { header: "id", key: "id", width: 7 },
          {
            header: "ContentSubUnit_code",
            key: "ContentSubUnit_code",
            width: 13,
          },
          { header: "seq", key: "seq", width: 5 },
          { header: "sentence_text", key: "sentence_text", width: 30 },
          {
            header: "roman_sentence_text",
            key: "roman_sentence_text",
            width: 30,
          },
          {
            header: "ContentSettingTense_code",
            key: "ContentSettingTense_code",
          },
          {
            header: "ContentSettingSentencePattern_code",
            key: "ContentSettingSentencePattern_code",
          },
          { header: "dependent_clause_yn", key: "dependent_clause_yn" },
          { header: "sentence_subject", key: "sentence_subject" },
          { header: "sentence_verb", key: "sentence_verb" },
          { header: "sentence_direct_object", key: "sentence_direct_object" },
          {
            header: "sentence_indirect_object",
            key: "sentence_indirect_object",
          },
          { header: "sentence_complement", key: "sentence_complement" },
          { header: "sentence_adverb", key: "sentence_adverb" },
          { header: "sentence_etc", key: "sentence_etc" },
          { header: "sentence_voice_filename", key: "sentence_voice_filename" },
          { header: "learning_sentence_elements_yn", key: "learning_sentence_elements_yn" },
          { header: "learning_vocabulary_yn", key: "learning_vocabulary_yn" },
          { header: "vocabulary_text", key: "vocabulary_text" },
          { header: "delete_yn", key: "delete_yn" },
          { header: "create_datetime", key: "create_datetime" },
          { header: "update_datetime", key: "update_datetime" },
        ];
        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet("englemlining");
        worksheet.columns = map;
        // worksheet.columns = Object.keys(data.data[0]).map(el=>{
        //   return {header:el, key:el}
        // })
        worksheet.insertRows(2, data.data);
        const buffer = await workbook.xlsx.writeBuffer();
        fileSaver(new Blob([buffer]), fileName + ".xlsx");
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${backend}/contents/content_sentence/sentence/group`)
      .then((data) => {
        const groupList = data.data.data[0].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const courseList = data.data.data[1].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const stageList = data.data.data[2].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const chapterList = data.data.data[3].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const unitList = data.data.data[4].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const subUnitList = data.data.data[5].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        let colorList = { 0: ["#FFFFFF", "미정"] };
        const mList = [
          "sentence_subject",
          "sentence_verb",
          "sentence_direct_object",
          "sentence_indirect_object",
          "sentence_complement",
          "sentence_adverb",
          "sentence_etc",
        ];
        data.data.data[8].forEach((ele, idx) => {
          colorList[mList[idx]] = ["#" + ele.color, ele.name];
        });

        setGroups(groupList);
        setCourses(courseList);
        setStages(stageList);
        setChapters(chapterList);
        setUnits(unitList);
        setSubUnits(subUnitList);
        setSentencePatterns(data.data.data[6]);
        setTenses(data.data.data[7]);
        setConstituentColor(colorList);
        setLanguages(data.data.data[9])
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        }
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    const { current, pageSize } = tableParams.pagination;
    axios
      .post(
        `${backend}/contents/content_sentence/sentence/read?current=${current}&pageSize=${pageSize}`,
        { filter: tableParams.filters }
      )
      .then((data) => {
        getSourceData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, 
  [    
    JSON.stringify(tableParams.filters),
    JSON.stringify(tableParams.pagination.current),
    JSON.stringify(tableParams.pagination.pageSize),
    reRender
  ]);

  useEffect(()=>{
    setTableParams({
      ...tableParams,
      filters: {
        ...filter,
        errorStatus: tableParams.filters.errorStatus,
        searchFilter: tableParams.filters.searchFilter 
      }
    })
  },[])
  // useEffect(() => {
  //   axios
  //     .get(`${backend}/contents/content_sentence/constituent/morpheme_ready`, {
  //       withCredentials: true,
  //     })
  //     .then((data) => setMorphemeAuth(data.data))
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"100%", overflow: "auto" }}>
      <Modal
        destroyOnClose={true}
        open={phoneticProgress[0]}
        title="발음기호 생성"
        afterClose={() => {
          stopRef.current = false;
        }}
        footer={
          <Button
            disabled={stopRef.current}
            onClick={() => {
              isStop.phonetic = true;
            }}
          >
            중지
          </Button>
        }
      >
        <div style={{ textAlign: "center" }}>
          <SentenceProgress per={phoneticProgress}></SentenceProgress>
        </div>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={createFileProgress[0]}
        title="음성파일 생성"
        afterClose={() => {
          stopRef.current = false;
        }}
        footer={
          <Button
            disabled={stopRef.current}
            onClick={() => {
              isStop.createFile = true;
            }}
          >
            중지
          </Button>
        }
      >
        <div style={{ textAlign: "center" }}>
          <SentenceProgress per={createFileProgress}></SentenceProgress>
        </div>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={morphemeProgress[0]}
        title="문장성분 분석"
        afterClose={() => {
          stopRef.current = false;
        }}
        footer={
          <Button
            disabled={stopRef.current}
            onClick={() => {
              isStop.morpheme = true;
              setMorphemeProgress([false,0,0])
            }}
          >
            중지
          </Button>
        }
      >
        <div style={{ textAlign: "center" }}>
          <SentenceProgress per={morphemeProgress}></SentenceProgress>
        </div>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={upLoadPopup}
        title="음성파일 압축해서 서버로 업로드"
        maskClosable={false}
        onCancel={() => {
          if(!confirmLoading) {
            setUpLoadPopup(false);
          }
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              disabled={confirmLoading}
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                loading={confirmLoading}
                type="primary"
                onClick={UploadOkHandler}
                icon={<UploadOutlined />}
              >
                업로드
              </Button>
              <Button
                disabled={confirmLoading}
                onClick={() => {
                  setUpLoadPopup(false);
                }}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Spin spinning={confirmLoading}>
        <Form ref={formRef} layout="vertical">
          <Form.Item name="upLoadUnit" label="압축 단위">
            <Radio.Group defaultValue={"chapter"}>
              <Radio value={"chapter"}>챕터</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        </Spin>
        {uploadProgress[0] ? <UploadProgressBar per={uploadProgress}></UploadProgressBar> : null}
      </Modal>

      <Modal
        destroyOnClose={true}
        open={sentenceUpload}
        title="영어문장 업로드"
        maskClosable={false}
        onCancel={() => {
          setSentenceUpload(false);
          setFileList([]);
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
                setFileList([]);
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                type="primary"
                onClick={sentenceUploadHandler}
                icon={<UploadOutlined />}
                disabled={fileList.length === 0}
              >
                업로드
              </Button>
              <Button
                onClick={() => {
                  setSentenceUpload(false);
                  setFileList([]);
                }}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={formRef}
          layout="vertical"
          initialValues={{ uploadOption: 1 }}
        >
          <Upload {...sentenceUploadProps}>
            <Button icon={<UploadOutlined />}>파일 첨부</Button>
          </Upload>
          <div style={{ height: "100px" }}></div>
          <Form.Item name="uploadOption" label="문장코드 중복시 처리조건">
            <Radio.Group>
              <Space direction="vertical">
                <Radio value={1}>기존 데이터 삭제 후 전부 업로드</Radio>
                <Radio value={2}>기존 데이터 유지</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ minWidth: "100px", textAlign: "left" }}>문장 목록</span>
        <Space wrap>
          <Select
            options={[{ value: "all", label: "그룹: 전체" }, ...groups]}
            style={{ width: 200, textAlign: "left" }}
            defaultValue="all"
            value={tableParams.filters.group}
            onChange={groupFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "코스: 전체" },
              ...courses.filter(
                (el) =>
                  tableParams.filters.group === "all" ||
                  tableParams.filters.group === el.group_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.group === "all"}
            defaultValue="all"
            value={tableParams.filters.course}
            onChange={courseFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "스테이지: 전체" },
              ...stages.filter(
                (el) =>
                  tableParams.filters.course === "all" ||
                  tableParams.filters.course === el.course_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.course === "all"}
            defaultValue="all"
            value={tableParams.filters.stage}
            onChange={stageFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "챕터: 전체" },
              ...chapters.filter(
                (el) =>
                  tableParams.filters.stage === "all" ||
                  tableParams.filters.stage === el.stage_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.stage === "all"}
            defaultValue="all"
            value={tableParams.filters.chapter}
            onChange={chapterFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "유닛: 전체" },
              ...units.filter(
                (el) =>
                  tableParams.filters.chapter === "all" ||
                  tableParams.filters.chapter === el.chapter_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.chapter === "all"}
            defaultValue="all"
            value={tableParams.filters.unit}
            onChange={unitFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "서브유닛: 전체" },
              ...subUnits.filter(
                (el) =>
                  tableParams.filters.unit === "all" ||
                  tableParams.filters.unit === el.unit_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.unit === "all"}
            defaultValue="all"
            value={tableParams.filters.subUnit}
            onChange={subUnitFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "문장상태: 전체" },
              { value: "N", label: "운영" },
              { value: "Y", label: "편집" },
            ]}
            style={{ width: 150, textAlign: "left" }}
            defaultValue="all"
            value={tableParams.filters.sentenceStatus}
            onChange={sentenceStatusFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "에러상태: 전체" },
              { value: "정상", label: "정상" },
              { value: "에러", label: "에러" },
              { value: "숫자", label: "숫자" },
              { value: "성분", label: "성분" },
              { value: "기호", label: "기호" },
              { value: "발음", label: "발음" },
            ]}
            style={{ width: 150, textAlign: "left" }}
            defaultValue="all"
            value={tableParams.filters.errorStatus}
            onChange={errorStatusFilter}
          ></Select>
          <Input.Search
            placeholder="영어 문장을 입력하세요."
            onSearch={onSearch}
            allowClear={true}
            style={{
              width: 250,
              marginLeft: "5px",
            }}
          />
          <Button
            onClick={() => {
              setSentenceUpload(true);
            }}
          >
            <UploadOutlined />
            영어문장 업로드
          </Button>
          <Button onClick={phoneticAll}>
            <PlusOutlined />
            발음기호 생성
          </Button>
          <Button disabled={loading} onClick={constituentAll}>
            <PlusOutlined />
            성분분석
          </Button>
          <Button onClick={createVoiceFileAll}>
            <PlusOutlined />
            음성파일 생성(1.0)
          </Button>
          <Button onClick={excelDownload}>
            <DownloadOutlined />
            문장 다운로드
          </Button>
          <Button
            onClick={() => {
              setUpLoadPopup(true);
            }}
          >
            <UploadOutlined />
            음성파일 압축해서 서버로 업로드
          </Button>
          <ReloadOutlined
            style={{ fontSize: "20px" }}
            onClick={() => {
              setReRender(!reRender);
            }}
          />
        </Space>
      </div>

      <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
      <StyledTable
        className="pageTable"
        rowSelection={{
          selectedRowKeys: selectedKeys,
          onChange: (keys, rows) => {
            setStartEnd([0, rows.length - 1]);
            setSelectedRows(rows.sort((a, b) => a.num - b.num));
            setSelectedKeys(keys.sort((a, b) => a - b));
          },
        }}
        columns={columns}
        rowKey="id"
        dataSource={sourceDataKor}
        loading={loading}
        pagination={tableParams.pagination}
        onChange={handleTableChange}
        footer={() => (
          <div style={{ textAlign: "left" }}>
            <Space>
              <Button
                hidden={
                  sourceDataKor.length || tableParams.filters.subUnit === "all"
                    ? true
                    : false
                }
                onClick={() => {
                  insertHandler({
                    seq: 0,
                    ContentSubUnit_code: tableParams.filters.subUnit,
                  });
                }}
              >
                <PlusOutlined />
                문장 추가
              </Button>
              <Button onClick={deleteHandler}>
                <DeleteFilled />
                선택문장 삭제
              </Button>
              <Button onClick={runningHandler}>
                <EditFilled />
                선택문장을 '운영'상태로 변경
              </Button>
              <Button onClick={errorHandler}>
                오류검사
              </Button>
              <Button onClick={guide}>
                편집지침
              </Button>
            </Space>
          </div>
        )}
        scroll={{ x:100, y:"100%"}}
      />
      </div>
    </div>
  );
}

export default SentenceEng;
